import { StateNodeType } from '@sierralabs/state-machine';
import React, { useEffect, useRef, useState } from 'react';
import { useFormUpsert } from '../Form.hooks';
import { useFormContext } from '../FormContext';
/**
 * FormDataSource provides a built-in way to save form data utilizing the form
 * template and schema entity models.
 */
export const FormDataSource = ({ formTemplateVersion, disabled, formData, children }) => {
    var _a;
    const { stateMachine, entitySchema, changedFormValue } = useFormContext();
    const stateMachineRef = useRef(stateMachine);
    stateMachineRef.current = stateMachine;
    const previousFormValueRef = useRef(changedFormValue);
    const [formId, setFormId] = useState();
    const { upsertedData, isUpserting, upsertError, upsertFormData } = useFormUpsert();
    useEffect(() => {
        if ((upsertedData === null || upsertedData === void 0 ? void 0 : upsertedData.id) || (formData === null || formData === void 0 ? void 0 : formData.id)) {
            setFormId((upsertedData === null || upsertedData === void 0 ? void 0 : upsertedData.id) || (formData === null || formData === void 0 ? void 0 : formData.id));
        }
    }, [upsertedData, formData]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (disabled) {
            return;
        }
        const stateNode = ((_a = stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.currentState) === null || _a === void 0 ? void 0 : _a.path)
            ? (_b = stateMachineRef.current) === null || _b === void 0 ? void 0 : _b.getStateNode((_c = stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.currentState) === null || _c === void 0 ? void 0 : _c.path)
            : undefined;
        if (changedFormValue && previousFormValueRef.current !== changedFormValue) {
            previousFormValueRef.current = changedFormValue;
            const data = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.reduce((data, column) => {
                // make sure to only upsert form data of actual entity schema fields
                if (changedFormValue[column.name]) {
                    data[column.name] = changedFormValue[column.name];
                }
                return data;
            }, {});
            upsertFormData({
                id: formId,
                formTemplateVersionId: formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.id,
                formTemplateId: formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.formTemplate.id,
                version: formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.version,
                stateNodePath: (_d = stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.currentState) === null || _d === void 0 ? void 0 : _d.path,
                tableName: entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.tableName,
                isFinal: (stateNode === null || stateNode === void 0 ? void 0 : stateNode.type) === StateNodeType.Final,
                data
            });
        }
    }, [
        disabled,
        formId,
        changedFormValue,
        entitySchema,
        upsertFormData,
        formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.id,
        formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.formTemplate.id,
        formTemplateVersion === null || formTemplateVersion === void 0 ? void 0 : formTemplateVersion.version,
        (_a = stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.currentState) === null || _a === void 0 ? void 0 : _a.path
    ]);
    return React.createElement(React.Fragment, null, children);
};
export default FormDataSource;
//# sourceMappingURL=FormDataSource.js.map